import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';
import { SPECIALS } from '~/src/common/theme';

export const Button = styled.button`
  all: unset;
  align-self: baseline;
  text-transform: uppercase;

  > span {
    font-size: 1em;
    display: block;
  }
`;

export const Content = styled.span<{ $textColor: keyof typeof COLORS }>`
  display: inline-flex;
  align-items: center;
  gap: 0.3em;
  line-height: 1em;
  white-space: nowrap;
  padding: 0.3em 0.4em 0.25em;
  border-radius: 0.3em;
  font-size: 0.85em;
  font-weight: 700;
  cursor: pointer;
  background-color: ${COLORS.NEUTRAL_WHITE};

  &:hover {
    background-color: ${SPECIALS.WHITE_OVERLAY};
  }

  &:active {
    background-color: ${SPECIALS.WHITE_OVERLAY};
  }

  code {
    color: ${({ $textColor }) => COLORS[$textColor]};
    font-family: inherit;
  }

  [class*='icon-'] {
    width: 1.1em;
    text-align: right;
  }
`;
